import { Component, input } from '@angular/core';
import { DialogRef } from '../../../shared/services/modal.service';

@Component({
  standalone: false,
  selector: 'app-phone-reports-test-result-modal',
  templateUrl: './phone-reports-test-result-modal.component.html',
})
export class PhoneReportTestResultModalComponent {
  readonly dialogRef = input<DialogRef>();
  readonly reportId = input<number>();

  onCloseClick(): void {
    this.dialogRef().close(false);
  }
}
